import React from 'react';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import AxisConfig from '../AxisConfig';
import MainConfig from './MainConfig';
import SeriesConfig from '../SeriesConfig';
import LegendControl from '../LegendControl';

export const DEFAULT_CONFIGURATION = {
  chartTitle: null,
  orientation: 'vertical',
  groupMode: 'stacked',
  percentStack: false,
  legendAnchor: 'bottom-right',
  showLabels: true,
  horizontalAxis: {
    enabled: true,
    title: '',
    labelSlant: 0,
  },
  verticalAxis: {
    enabled: true,
    title: '',
    labelSlant: 0,
  },
  scale: 1,
  axisPrefix: null,
  axisSuffix: null,
  secondaryAxisPrefix: null,
  secondaryAxisSuffix: null,
  minValue: null,
  maxValue: null,
  useDataColor: true,
  colors: {},
  barSize: 65,
  reverse_BarChart: false,
  backgroundColor: 'transparent',
  gridColor: 'transparent',
};

function BarChartConfiguration({ meta, horizontalSortType, verticalSortType }) {
  const { get } = useReportConfiguration();

  return (
    <>
      <MainConfig meta={meta} />
      <LegendControl meta={meta} />
      <AxisConfig
        axis='horizontal'
        active={get('orientation') === 'horizontal'}
        showSort={get('orientation') === 'vertical'}
        sortType={horizontalSortType}
      />
      <AxisConfig
        axis='vertical'
        active={get('orientation') === 'vertical'}
        showSort={get('orientation') === 'horizontal'}
        sortType={verticalSortType}
      />
      <SeriesConfig meta={meta} />
    </>
  );
}

export default BarChartConfiguration;
